import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";

import BannerNews from "./components/BannerNews";
import BlockAnchor from "./blocks/BlockAnchor";
import BlockCards from "./blocks/BlockCards";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockTextCards from "./blocks/BlockTextCards";
import BlockTextList from "./blocks/BlockTextList";
import BlockSectorsCollectivities from "./blocks/BlockSectorsCollectivities";
import BlockSectorsFromLocalities from "./blocks/BlockSectorsFromLocalities";
import BlockSliderMultiple from "./blocks/BlockSliderMultiple";
import CardsReveal from "./components/CardsReveal";
import ListingFilter from "./components/ListingFilter";

// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();
    new BannerNews();

	// Blocks
	new BlockAnchor();
    new BlockCards();
	new BlockCollapse();
    new BlockSectorsCollectivities();
    new BlockSectorsFromLocalities();
    new BlockSliderMultiple();
    new BlockTextCards();
    new BlockTextList();

    new CardsReveal();
    new ListingFilter();
});

window.initMap = function () {
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};
